import ControllerWithSignal from '../scripts/controller-with-signal';

// https://github.com/scaleflex/filerobot-image-editor/blob/6263686363e57fcbc7f035741f3b095e79e1ef66/README.md?plain=1#L159
const filerobotImageEditorUrl = new URL(
  '../scripts/marketing-materials/filerobot-image-editor.min.js',
  import.meta.url,
).href;

// https://github.com/scaleflex/filerobot-image-editor/blob/6263686363e57fcbc7f035741f3b095e79e1ef66/packages/react-filerobot-image-editor/src/utils/translator.js#L105
const translationsUrl = new URL(
  '../scripts/marketing-materials/filerobot-translations.json',
  import.meta.url,
).href;

export default class extends ControllerWithSignal {
  static targets = ['editor', 'icon'];
  static values = {
    locale: String,
  };

  editor = null;

  connectWithSignal(signal) {
    this.load().catch(() => {}); // preload

    const fileInput = this.element.querySelector('input[type="file"]');

    fileInput.addEventListener('change', this.fileChange, { signal });

    if (fileInput.value) {
      fileInput.value = '';
      fileInput.dispatchEvent(new Event('change'));
    }
  }

  disconnectWithSignal() {
    this.terminate();
  }

  async load() {
    const [, translations, { cropFolderPresets }] = await Promise.all([
      import(filerobotImageEditorUrl),
      fetch(translationsUrl).then((response) => {
        if (!response.ok) {
          throw new Error(
            `Failed to fetch translations: ${response.status} ${response.statusText}`,
          );
        }

        return response.json();
      }),
      import('../scripts/marketing-materials/presets.js'),
    ]);

    console.log(translations);

    return {
      FilerobotImageEditor: window.FilerobotImageEditor,
      translations: Object.fromEntries(
        translations.map((translation) => [
          translation.translation_key,
          translation.translations[this.localeValue],
        ]),
      ),
      cropFolderPresets,
    };
  }

  fileChange = async (event) => {
    const file = event.target.files[0];
    this.terminate();

    if (!file) return;

    const { FilerobotImageEditor, translations, cropFolderPresets } = await this.load();

    cropFolderPresets[0].icon = this.iconTarget.outerHTML;

    const url = URL.createObjectURL(file);
    const editor = new FilerobotImageEditor(this.editorTarget, {
      source: url,
      defaultSavedImageName: file.name,
      translations,
      useBackendTranslations: false,

      Crop: {
        presetsFolders: cropFolderPresets,
      },

      onSave(imageInfo) {
        // https://github.com/scaleflex/filerobot-image-editor/blob/6263686363e57fcbc7f035741f3b095e79e1ef66/public/init.js#L75
        const url = imageInfo.imageBase64;
        let tmpLink = document.createElement('a');
        const { fullName: fileName } = imageInfo;

        tmpLink.href = url;
        tmpLink.download = fileName;
        tmpLink.style = 'position: absolute; z-index: -111; visibility: none;';
        document.body.appendChild(tmpLink);
        tmpLink.click();
        document.body.removeChild(tmpLink);
        tmpLink = null;
      },
    });
    this.editor = editor;

    editor.render();
  };

  terminate() {
    this.editor?.terminate();
    this.editor = null;
  }
}
